import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelPaperConsultAll } from "../../functions/Report.ExportPaperAll";
import { formatDataPaperAll } from "../../utils/Report.Format";
import { FilterYearType } from "../common/ReportFilters";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
} from "../../../../utils/useStyle";

const initialData = {
  jan: 0,
  feb: 0,
  mar: 0,
  apr: 0,
  may: 0,
  jun: 0,
  jul: 0,
  aug: 0,
  sep: 0,
  oct: 0,
  nov: 0,
  dec: 0,
};

const ReportCountConsult = ({ userDept }) => {
  const [year, setYear] = React.useState({ label: "ทุกปี", value: "ALL" });
  const [type, setType] = React.useState({ label: "-", value: "NONE" });
  const [loading, setLoading] = React.useState("");
  const [data, setData] = React.useState(initialData);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getCatheterReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          const monthData = response.data;
          setData({
            jan: (monthData.jan?.adult || 0) + (monthData.jan?.kid || 0),
            feb: (monthData.feb?.adult || 0) + (monthData.feb?.kid || 0),
            mar: (monthData.mar?.adult || 0) + (monthData.mar?.kid || 0),
            apr: (monthData.apr?.adult || 0) + (monthData.apr?.kid || 0),
            may: (monthData.may?.adult || 0) + (monthData.may?.kid || 0),
            jun: (monthData.jun?.adult || 0) + (monthData.jun?.kid || 0),
            jul: (monthData.jul?.adult || 0) + (monthData.jul?.kid || 0),
            aug: (monthData.aug?.adult || 0) + (monthData.aug?.kid || 0),
            sep: (monthData.sep?.adult || 0) + (monthData.sep?.kid || 0),
            oct: (monthData.oct?.adult || 0) + (monthData.oct?.kid || 0),
            nov: (monthData.nov?.adult || 0) + (monthData.nov?.kid || 0),
            dec: (monthData.dec?.adult || 0) + (monthData.dec?.kid || 0),
          });
        }
      } catch (error) {
        console.error("Error fetching consult report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const listTable = [
    { name: "ม.ค.", count: data?.jan },
    { name: "ก.พ.", count: data?.feb },
    { name: "มี.ค.", count: data?.mar },
    { name: "เม.ย.", count: data?.apr },
    { name: "พ.ค.", count: data?.may },
    { name: "มิ.ย.", count: data?.jun },
    { name: "ก.ค.", count: data?.jul },
    { name: "ส.ค.", count: data?.aug },
    { name: "ก.ย.", count: data?.sep },
    { name: "ต.ค.", count: data?.oct },
    { name: "พ.ย.", count: data?.nov },
    { name: "ธ.ค.", count: data?.dec },
  ];

  return (
    <div className="my-10">
      <div className={SCREENIPAD}>
        <div className={STYLEHEAD}>
          จำนวนใบปรึกษาที่ได้รับทั้งหมดต่อปี
          <div className={STYLEBODY}>
            แยกตามเดือน ของปี {year.label}" ประเภทสาย "{type.label}"
          </div>
        </div>
        <div className={FLEXDROPDOWN}>
          <FilterYearType
            year={year}
            setYear={setYear}
            type={type}
            setType={setType}
          />
          <ButtonExcel
            onClick={() => {
              ExcelPaperConsultAll(
                formatDataPaperAll(data),
                year,
                type,
                setLoading
              );
            }}
            loading={loading}
          />
        </div>
      </div>
      <div className={BARCHART}>
        <BarChart
          width={700}
          height={300}
          data={listTable}
          margin={{ top: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar
            dataKey="count"
            fill="#d8b4fe"
            minPointSize={5}
            label={{ fill: "#111827" }}
          />
        </BarChart>
      </div>
    </div>
  );
};

export default ReportCountConsult;
